import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PaymentForm from "./PaymentForm";
import { useGetPaymentMethodsQuery } from "../../../store/payments/paymentsApi";
import ChoosePayment from "./ChoosePayment";
import { STRIPE_PUBLISHABLE_KEY } from "../../../config";
import PaymentHistory from "./PaymentHistory";

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY || "");

const Payments = () => {
  const { data, isLoading } = useGetPaymentMethodsQuery();

  const list = data?.data?.data?.map((pay) => ({
    label: pay.card.display_brand + " **** **** **** " + pay.card.last4,
    value: pay.id,
  }));
  return (
    <Elements stripe={stripePromise}>
      <>
        <h4 className="page-title">Payments</h4>
        {isLoading ? <p>Loading...</p> : <div className="my-8">
          {(list && Array.isArray(list) && list.length) ? (
			<>
				<ChoosePayment
					list={list || []}
					customerId={data?.data.data[0]?.customer || ""}
				/>
				<PaymentHistory />
			</>
          ) : (
            <PaymentForm />
          )}
        </div>}
      </>
    </Elements>
  );
};

export default Payments;
